export default [
  {
    name: 'carouselmangent',
    path: '/membercenter/carouselmangent',
    component: () => import('../views/carouselMangent/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'commodity_management',
    path: '/membercenter/commodity_management',
    component: () => import('../views/commodity_management/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'activity_management',
    path: '/membercenter/activity_management',
    component: () => import('../views/activity_management/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'points_order',
    path: '/membercenter/points_order',
    component: () => import('../views/pointsOrder/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'member_management',
    path: '/membercenter/member_management',
    component: () => import('../views/member_management/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'feedback',
    path: '/membercenter/feedback',
    component: () => import('../views/feedback/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'shareAct',
    path: '/membercenter/shareAct',
    component: () => import('../views/shareAct/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'cashOrder',
    path: '/membercenter/cashOrder',
    component: () => import('../views/cashOrder/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'yz_order',
    path: '/membercenter/yzOrder',
    component: () => import('../views/yzOrder/index'),
    meta: {
      keepAlive: false,
    },
  },
];
